import type { TokenEmail } from "@/interfaces/emailPreview";

interface TokenMenuProps {
  items: TokenEmail[];
  activeIdx?: number;
  onInsert: (token: TokenEmail) => void;
  showHint?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export function TokenMenu({
  items,
  activeIdx = -1,
  onInsert,
  showHint,
  className,
  style,
}: TokenMenuProps) {
  return (
    <div
      className={className}
      style={{
        border: "1px solid var(--color-smoke)",
        borderRadius: 8,
        boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
        minWidth: 260,
        padding: "6px 0",
        textTransform: "none",
        letterSpacing: "normal",
        fontWeight: 400,
        background: "white",
        ...style,
      }}
    >
      {showHint && (
        <div
          style={{
            fontFamily: "var(--font-lato)",
            fontSize: 11,
            color: "var(--color-graphite)",
            padding: "10px 14px 8px",
            borderBottom: "1px solid var(--color-card-border)",
            marginBottom: 4,
            lineHeight: 1.4,
          }}
        >
          Type @ in any eligible text field to see this list of tags.
        </div>
      )}
      {items.map((token, i) => (
        <button
          key={token.tag}
          type="button"
          onMouseDown={(e) => {
            e.preventDefault();
            onInsert(token);
          }}
          className={i !== activeIdx ? "hover:bg-clear-dust" : ""}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "8px 14px",
            width: "100%",
            fontFamily: "var(--font-lato)",
            fontSize: 13,
            color: "var(--color-rodeo-black)",
            cursor: "pointer",
            border: "none",
            background: i === activeIdx ? "var(--color-clear-dust)" : "transparent",
          }}
        >
          <span>{token.label}</span>
          <code
            style={{
              fontSize: 11,
              color: "var(--color-graphite)",
              background: "var(--color-wax)",
              padding: "2px 6px",
              borderRadius: 3,
            }}
          >
            {token.tag}
          </code>
        </button>
      ))}
    </div>
  );
}
